import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Adding Buttons",
description: "Learn how to add buttons to Freon projections, define their behavior using box roles and custom actions, and style them with icons using CSS or SCSS.",
tags: [ "buttons", "editor customization", "custom actions", "boxRole", "icon buttons", "styling", "projectional editor", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.373Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};